export default __webpack_public_path__ + "static/media/r1.5de133cc.jpg";